import { getRentalPortalListing } from '../../../../../../api'
import { useAsyncEntity } from '../../../../../Entity'
import { getListingProfilePreparedData } from '../../../../../RentalPortalListing'

export function useRentalPortalListingsFormEntity(listingId) {
  async function getProfileData() {
    return listingId ? getRentalPortalListing(listingId) : { data: null }
  }

  const { entityData, handleEntityReload, isLoading, serverError } =
    useAsyncEntity({
      entityId: listingId,
      getProfileData,
    })

  return {
    handleReloadListing: handleEntityReload,
    isLoading: Boolean(listingId) && isLoading,
    listing: getListingProfilePreparedData(entityData),
    loadError: listingId ? serverError : null,
  }
}
